export default __webpack_public_path__ + "static/media/cabinet002.d808d293.jpeg";